import { render, staticRenderFns } from "./PackageList.vue?vue&type=template&id=33c761eb&scoped=true&"
import script from "./PackageList.vue?vue&type=script&lang=js&"
export * from "./PackageList.vue?vue&type=script&lang=js&"
import style0 from "./PackageList.vue?vue&type=style&index=0&id=33c761eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!//////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c761eb",
  null
  
)

export default component.exports